<template>
  <v-container>
    <sub-navigation></sub-navigation>

    <JednorazovyNakupDialog v-if="jednorazovy_nakup_id!=null" :id="jednorazovy_nakup_id.toString()" @close="jednorazovy_nakup_id=null" :moje="true"></JednorazovyNakupDialog>

    <!-- <v-layout row wrap>
      <v-flex xs12>
        <h1 class="h2 mb-30">Jednorázové nákupy</h1>
      </v-flex>
    </v-layout> -->
    <v-layout row wrap class="mt-3">
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-0"
          :pagination.sync="pagination"
          :total-items="pagination.totalItems"
          :rows-per-page-items="[25, 50, 100, 200]"
          :loading="loadingTable"
        >
          <template v-slot:items="props">
            <td>{{ props.item.datum | formatSimpleDate }}</td>
            <td>{{ props.item.variabilni_symbol }}</td>
            <td>{{ props.item.castka_celkem | formatMoney }} {{props.item.mena.zkratka}}</td>
            <td><span v-if="props.item.castka_celkem_fixace>0">{{ props.item.castka_celkem_fixace | formatMoney }} {{props.item.mena.zkratka}}</span><span v-else>--</span></td>
            <td>{{ props.item.stav_objednavky.nazev }}</td>
            <td class="text-xs-right">
              <v-btn color="orange" @click="detailClick(props.item.id)" dark class="elevation-0 ma-0 bold"><v-icon class="ma-0">remove_red_eyes</v-icon> Detail</v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import Base from '../Base'
  import JednorazovyNakupDialog from '@/components/JednorazovyNakupDialog'
  export default {
    extends: Base,
    data () {
      return {
        loading: true,
        dialogDetail: false,
        dialogCreate: false,
        headers: [
          { text: 'Datum', value: 'datum', sortable: false },
          { text: 'Číslo obj. (VS)', value: 'variabilni_symbol', sortable: false },
          { text: 'Částka obj.', value: 'castka_celkem', sortable: false },
          { text: 'Částka fixace', value: 'castka_celkem_fixace', sortable: false },
          { text: 'Stav', value: 'stav_objednavky.nazev', sortable: false },
          { text: 'Detail nákupu', value: null, sortable: false, align: "right" }
        ],
        items: [],
        timeout: null,
        counter: 0,
        pagination: {
          descending: true,
          page: 1,
          rowsPerPage: 25,
          sortBy: "datum",
          totalItems: 0,
          pages: 0
        },
        detailItem: null,
        loadingDetail: false,
        jednorazovy_nakup_id: null,
        loadingTable: false
      }
    },
    props: {
      id: String
    },
    watch: {
      pagination: {
    		handler: function(newValue) {
          if (!this.loadingTable)
    			   this.load();
    		},
    		deep: true
    	},
    },
    mounted () {
      this.load(() => {
        if (typeof this.$props.id !== "undefined" && this.$props.id.length > 0)
          this.detailClick(this.$props.id);
      });
    },
    methods: {
      load (f) {
        this.counter++;
        this.loadingTable = true;
        this.items = [];
        window.API.post("nakupy/jednorazove-nakupy/search", {
          pagination: this.pagination,
          s: this.search,
          echo: this.counter
        }).then(function(body) {
          if (this.counter != body.echo)
            return;
          this.items = body.data;
          this.pagination.sortBy = body.sort.sortBy;
          this.pagination.descending = body.sort.descending;
          this.pagination.page = body.sort.page;
          this.pagination.rowsPerPage = body.sort.rowsPerPage;
          this.pagination.totalItems = body.sort.totalItems;
          this.pagination.pages = body.sort.pages;
          this.loading = false;
          this.loadingTable = false;
          if (typeof f === "function")
            f();
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      },
      detailClick (v) {
        this.jednorazovy_nakup_id = v.toString();
      }
    },
    components: {
      JednorazovyNakupDialog
    }
  }
</script>
